import {ADOBE_GAME_NAME} from "modules/constants";
import i18n from "i18next";
import {IDictionary} from "modules/types";

interface IAnalyticsProps {
	section: string;
	eventName?: string;
	videoName?: string;
	voteSource?: string;
	score?: number;
	team?: string;
	optional?: IDictionary<string | number>;
}

let trackEvent = "pageLoad";

export const trackAdobeAnalytics = ({section, eventName, optional, ...other}: IAnalyticsProps) => {
	const pageName = `games:${ADOBE_GAME_NAME}${section}:microsite`;
	const dataLayerEvent = eventName || trackEvent;

	if (window.dataLayer) {
		window.dataLayer.push({
			event: dataLayerEvent,
			// fifaspid: '',
			// fifaId: '',
			// userCountry: '', // Commented lines are for SSO
			userLanguage: i18n.language,
			userStatus: "not logged in", // TODO: change after SSO done
			pageName,
			language: i18n.language,
			...other,
			...optional,
		});
		if (dataLayerEvent === "pageLoad") {
			trackEvent = "viewChange";
		}
	}
};
